module.exports = __webpack_public_path__ + "static/media/mr2_img_annual_dist.ff10783e.png";